module.exports = __webpack_public_path__ + "img/ConjuntoEletricoBdgd.70f0841e.png";